import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.988}
    height={25.989}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 41796 41796"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:463.172}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974348080288">
        <path
          d="M14634 14634c826-826 825-2176 0-3001L9286 6285c-826-826-2176-827-3002-1v1c-826 825-826 2176 0 3002l5348 5347c825 826 2176 826 3002 0zM27162 27162c-826 826-826 2176 0 3001l5348 5349c825 825 2175 826 3000 0h1c826-826 826-2176 1-3002l-5348-5348c-826-826-2176-826-3002 0zM12039 20899v-1c0-1168-954-2122-2122-2122H2354c-1168 0-2122 954-2122 2122v1c0 1167 954 2123 2122 2123h7563c1168 0 2122-956 2122-2123zM29756 20899v-1c0-1168 955-2122 2123-2122h7562c1168 0 2123 954 2123 2122v1c0 1167-955 2123-2123 2123h-7562c-1168 0-2123-956-2123-2123zM20897 12039h1c1168 0 2122-954 2122-2122V2354c0-1168-954-2122-2122-2122h-1c-1167 0-2123 954-2123 2122v7563c0 1168 956 2122 2123 2122zM20898 29757h1c1167 0 2122 955 2122 2122v7563c0 1168-955 2123-2122 2123h-1c-1168 0-2123-955-2123-2123v-7563c0-1167 955-2122 2123-2122zM27162 14634c-826-826-826-2176 0-3001l5348-5348c826-826 2175-826 3001-1l1 1c825 825 826 2176 0 3002l-5348 5348c-826 825-2176 825-3002-1zM14634 27162c826 826 826 2176 0 3001l-5348 5348c-826 826-2176 826-3001 1l-1-1c-825-825-826-2176 0-3002l5348-5348c826-825 2176-825 3002 1z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
